<style scoped lang="stylus" rel="stylesheet/stylus">
video
  display none
</style>

<template>
	<div @touchstart="init">
		<video
			:key="flag"
			width="250"
			height="200"
			ref="video"
			muted="muted"
			autoplay="autoplay"
			x5-video-player-fullscreen="true"
			x5-playsinline
			playsinline="playsinline"
			webkit-playsinline
			x5-video-player-type="h5"
		></video>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'videoPoster',
	provide() {
		return {
			videoPoster: this
		}
	},
	props: {},
	data() {
		return {
			flag: this.$common.getTimeStampId16(),
			isPlayed: false
		}
	},
	methods: {
		init() {
			if (!this.isPlayed) {
				this.$refs.video.play()
				this.isPlayed = true
			}
		},
		async getPoster(src, isNeedReflash = true) {
			if (!this.isPlayed) return null
			const image = await this.loadVideo(src)
			isNeedReflash && this.refresh()
			return image
		},
		async loadVideo(src) {
			return new Promise(resolve => {
				const video = this.$refs.video
				video.src = src
				video.crossOrigin = 'anonymous'

				video.onloadeddata = () => {
					const canvas = document.createElement('canvas')
					canvas.width = video.videoWidth
					canvas.height = video.videoHeight
					canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)

					const image = canvas.toDataURL('image/png')
					resolve(image)
				}
			})
		},
		refresh() {
			this.flag = this.$common.getTimeStampId16()
			this.isPlayed = false
		}
	}
}
</script>
